import React, { useState, useContext, useEffect } from 'react'
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Space, Table, Tooltip } from 'antd';
import systemConfig from '../../../../config/systematic';
import getList from '../../../universal/getList';
import PurchaseOrderEdit from '../../orderManagement/PurchaseOrderEdit';
import moment from 'moment';

import WebUniversalReport, { WUExtendPropsType } from '../../../system/WebUniversalReport';
import dayjs from 'dayjs';
import { showCustomNotification, useNotificationInstance } from '../../../../utils/extend/AntdNotificationEx';
import AntDraggableModal from '../../../../utils/extend/AntDraggableModal';
import fetchApi from '../../../../utils/api/fetchApi';
import { SocketContext } from '../../../../App';


const { RangePicker } = DatePicker;
export default function PurOrderQuery() {
  const useContextData = useContext(SocketContext);
  const { contextData, setContextData } = useContextData;
  /** 后端数据wmService */
  let wmService: any = systemConfig.wmService;
  const notificationApi = useNotificationInstance()
  const [memoOpen, setMemoOpen] = useState<boolean>(false);
  const [memoData, setMemoData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [entrepotData, setEntrepotData] = useState<any>();

  // const [rows, setRows] = useState<Array<any>>([])
  // console.log("rows", rows);
  const [dataTypeData, setDataTypeData] = useState<Array<any>>();
  const [aa, setAa] = useState<Array<any>>([
    {
      id: "productName",
      name: "品名"
    },
    {
      id: "selfId",
      name: "品号"
    },
    {
      id: "univalence",
      name: "单价"
    },
    {
      id: "totalPrice",
      name: "总价"
    }
  ])

  const [bb, setBb] = useState<Array<any>>([
    {
      id: "=",
      name: "相等"
    },
    {
      id: "like",
      name: "相似"
    }
  ])
  const form = Form.useForm()[0];
  const form1 = Form.useForm()[0];


  const [initValues, setInitValues] = useState<any>();


  /** 表头内容 */
  let columnsHead: any = [
    {
      title: "编号",
      dataIndex: "id",
      render: (text: any) => <Tooltip placement="topLeft" title={text}>{
        (typeof text !== "undefined" && text !== null) ?
          (text.length >= 8 ? text.substring(0, 6) + '....' : text)
          : ''
      }</Tooltip>
      // render: (text: any) => (text ? text.selfId ? text.selfId : "" : "")
    },
    {
      title: "单号",
      dataIndex: "orderId",
      render: (text: any) => <Tooltip placement="topLeft" title={text}>{
        (typeof text !== "undefined" && text !== null) ?
          (text.length >= 8 ? text.substring(0, 6) + '....' : text)
          : ''
      }</Tooltip>
    },
    {
      title: "日期",
      dataIndex: "createdAt",
      align: "center",
    },
    {
      title: "品号",
      dataIndex: "selfId",
    },

    {
      title: "品名",
      dataIndex: "productName",
    },
    {
      title: "单位",
      dataIndex: "productUnitName",
    },
    {
      title: "规格",
      dataIndex: "productSpecifications",
    },
    {
      title: "数量",
      dataIndex: "bNum",
      align: "center",

      render: (text: any) => (text ? text.toFixed(2) : 0)
    },
    {
      title: "单价",
      dataIndex: "univalence",
      align: "center",

      render: (text: any) => (text ? text.toFixed(2) : 0)
    },
    {
      title: "金额",
      dataIndex: "totalPrice",
      align: "center",

      render: (text: any) => (text ? Number(text).toFixed(2) : 0)
    },
    {
      title: "部门",
      dataIndex: "deptName",
      align: "center",

    },
    {
      title: "备注",
      dataIndex: "memo",
      render: (text: any, record: any) => <Tooltip placement="topLeft" title={"点击修改备注"}>{
        <div onClick={() => openMemo(record)}>{text ? text : <span >.</span>}</div>
      }</Tooltip>
    },
    {
      title: '打印数',
      dataIndex: 'printNumber',
      align: "center",

    },
    // {
    //   title: '打印',
    //   dataIndex: 'print',
    //   align: "center",
    //   render: (text: any, record: any) => (<Button disabled={record.orderState === 99 && record.orderStatus === 3 ? false : true} size='small' type='primary' onClick={() => entrepotPrint.printOrder("purchaseOrderPrint", "purchaseProducts", "purchaseOrder", undefined, record.orderId)}>打印</Button>)
    // },
    // {
    //   title: "操作",
    //   dataIndex: 'operation',
    //   render: (text: any, record: any) =>
    //     <Space size="small">
    //       <Button size={"small"} type="text" onClick={() => survey.order(record.orderId, "VIEW", level, setPurOrderData, setModalPurOrderOpen)}>查看</Button>
    //       <Button disabled={level === 1 ? false : record.orderState !== 99 && record.orderStatus === 1 ? false : true} size={"small"} type="text" onClick={() => survey.order(record.orderId, "EDIT", level, setPurOrderData, setModalPurOrderOpen)}>编辑</Button>
    //     </Space>
    // },
  ]
  // const initData = (values: any, currentEx?: number, pageSizeEx?: number) => {


  //   fetchApi.GET(
  //     wmService,
  //     {
  //       apiId: "entrepotReport",
  //       apiExtend: 'purOrderQuery',
  //       apiData: {
  //         ...values,
  //         pageSize: pageSizeEx ? pageSizeEx : pageSize,
  //         current: currentEx ? currentEx : current
  //       }
  //     }
  //   ).then(res => {

  //     setTotal(res.data.total)
  //     setPageSize(res.data.pageSize)
  //     setCurrent(res.data.current)
  //     setInitValues(values)
  //     setRows(res.data.rows)
  //     setLevel(res.data.level)
  //      showCustomNotification(notificationApi!, {
  //     type: 'success',
  //     message:"搜索成功",
  // description:  "success"
  // });;

  //   }).catch((err) => {
  //     console.log("err", err);

  //   })
  // }

  // const onClosePurOrderOpen = (status: Boolean) => {
  //   setModalPurOrderOpen(false)
  //   if (status === true) {
  //     initData(initValues)
  //   }
  // }
  const onChangeMemo = (record: any) => {
    form1.validateFields()
      .then((values: any) => {

        fetchApi.POST(wmService, {
          apiId: "entrepot",
          apiExtend: "chageEmeo",
          apiData: {
            ...values,
            orderDetailId: memoData.orderDetailId,
            orderType: 2

          }
        }).then((res) => {
          setMemoOpen(false)
          setInitValues({ ...initValues, forcedRefresh: true })


        }).catch((err) => {
          setMemoOpen(false)
          showCustomNotification(notificationApi!, {
            type: "error",
            message: "修改失败",
            description: JSON.stringify(err)
          });
        })

      }).catch((err) => {
        showCustomNotification(notificationApi!, {
          type: 'warning',
          message: "无法通过数据校验",
          description: "请输入所需数据!"
        });
      })



  }
  const openMemo = (record: any) => {

    setMemoOpen(true)
    setMemoData({ orderDetailId: record.id })
    form1.setFieldsValue({ "memo": record?.memo })

  }
  const onFinish = () => {
    setIsLoading(true)
    form.validateFields()
      .then((values: any) => {
        // initData(values)
        setInitValues({
          ...values,
          entrepotId: contextData?.currentEntrepotId,
          entrepotName: contextData?.currentEntrepotName,

          time: values.chooseTime ? {
            startTime: dayjs(values.chooseTime[0]).format("YYYY-MM-DD"),
            endTime: dayjs(values.chooseTime[1]).format("YYYY-MM-DD"),
          } : null,
          mountDataOptions: {
            userMount: {
              isEmployees: true,
              isDept: true,
              isUserAreas: true
            }
          },
        })
        setIsLoading(false)

      }).catch((err) => {
        showCustomNotification(notificationApi!, {
          type: 'warning',
          message: "无法通过数据校验",
          description: "请输入所需数据!"
        });
        setIsLoading(false)

      })



  }
  useEffect(() => {

    //同步获取数据 async - await
    const fetchData = async () => {
      fetchApi.GET(wmService,
        {
          apiId: 'generalData',
          apiVariable: 'dataStatusType',
          apiExtend: 'showLists'
        }
      ).then(res => {
        if (res.success) {
          const { dataStatusType } = res.data


          setDataTypeData(dataStatusType)
        }
      })
      // setCaOrderStatusData
    };
    fetchApi.GET(wmService, {
      apiId: 'entrepot',
      apiExtend: 'showListEx',
      apiData: {
        mountDataOptions: {
          userMount: {
            // isEmployees: true,
            // isDept:true,
            isUserEntrepots: true
          }
        },
      }
    }).then((res) => {
      if (res.success) {
        setEntrepotData(res.data)
      }
    })




    fetchData();
    //禁用规则
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); //初始化数据
  // 表格分页属性
  // const paginationProps = {
  //   showSizeChanger: true,
  //   showQuickJumper: false,
  //   showTotal: () => `共${total}条`,
  //   pageSize,
  //   current,
  //   total,
  //   onShowSizeChange: (current: number, pageSize: number) => changePageSize(pageSize, current),
  //   onChange: (current: number) => changePage(current, pageSize),
  // };
  // // 回调函数，切换页数
  // const changePage = (current: number, pageSize: number) => {
  //   if (loading === false) {
  //     initData(initValues, current, pageSize)
  //     loading = true
  //   }
  // }

  // // 回调函数,每页显示多少条
  // const changePageSize = (pageSize: number, current: number) => {
  //   if (loading === false) {
  //     initData(initValues, current, pageSize)
  //     loading = true

  //   }
  // };
  let extendProps: WUExtendPropsType = {
    apiId: 'entrepotReport',
    apiExtend: "purOrderQuery",
    columns: columnsHead,
    // setPaRows: setRows,
    pagination: true,
    values: initValues,
    isDownloadExcel: true,
    printType: "purchaseOrderPrint",
    typeProducts: "purchaseProducts",
    primaryKeyName: "orderId",
    printApi: "purchaseOrder",
    EditComponent: PurchaseOrderEdit,
  };
  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={{ chooseTime: [dayjs().subtract(2, 'month'), dayjs()], dataStatusType: 1 }}
      >
        <Row>

          <Col span={3}>
            <Form.Item label="参数"
              name="parameters"
              rules={[{ required: false, message: '请选择参数!' }]}
            >
              <Select
                // mode="multiple"
                showSearch
                placeholder="参数"
                optionFilterProp="children"
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(aa, 'name')}
              </Select>
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item label="条件"
              name="condition"
              rules={[{ required: false, message: '请选择条件!' }]}
            >
              <Select
                // mode="multiple"
                showSearch
                placeholder="条件"
                optionFilterProp="children"
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(bb, 'name')}
              </Select>
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item label="参数值"
              name="parametersValue"
              rules={[{ required: false, message: '请输入参数值!' }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item
              label="日期"
              name="chooseTime"
            >
              <RangePicker

                format="YYYY-MM-DD"
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="仓库"
              name="entrepotIds"
              tooltip={"选中时，账套切换的仓库数据失效， 只支持选中的仓库数据查询"}
            >
              <Select

                mode='multiple'
                placeholder="多仓库"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(entrepotData, "entrepotName","entrepotId")}
              </Select>
            </Form.Item>
          </Col>
          {/* <Col span={1.5}>
            <Form.Item
              label="当前区域"
              name="isArea"
              valuePropName="checked"

            >
              <Checkbox ></Checkbox>
            </Form.Item>
          </Col> */}
          <Col span={2}>
            <Form.Item
              name="dataStatusType"
            >
              <Select
                defaultValue="数据状态"
                placeholder="数据状态"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(dataTypeData)}
              </Select>
            </Form.Item>
          </Col>

          {/* <Button onClick={() => DownloadExcel(rows, "purOrderQuery", { ...initValues })}>下载EXCEL文件</Button> */}
          <Col span={2}>
            <Form.Item >
              <Space>
                <Button loading={isLoading} htmlType="submit">
                  统计
                </Button >

              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>



      {/* <div style={{ marginTop: "20px" }}>
        <Table
          // scroll={{ y: 750 }}
          pagination={paginationProps}
          rowKey={(record: any, index: any) => index}
          columns={columnsHead}
          dataSource={rows}

        >
        </Table>
        {modalPurOrderOpen ? (<PurchaseOrderEdit data={purOrderData} closeModal={onClosePurOrderOpen}
        />)
          : null}
      </div> */}
      {memoOpen ? <AntDraggableModal
        title={"修改备注"}
        open={true}
        okText='确定'
        cancelText='取消'
        onOk={onChangeMemo}
        onCancel={() => setMemoOpen(false)}
        closable={false}
        maskClosable={false}
      >
        <Form

          form={form1}
          name="Edit"
          onFinish={onChangeMemo}
          onKeyDown={(e: any) => {
            if (e.key === 'Enter') {
              onChangeMemo(e)
            }
          }}>


          <Form.Item
            label="备注"
            name="memo"
            rules={[{ required: false, message: '请输入备注!' }]}>
            <Input />
          </Form.Item>



        </Form>
      </AntDraggableModal> : null}
      <WebUniversalReport props={extendProps}></WebUniversalReport>
    </>
  )
}

